import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PartystatusFilterCriteria from './PartystatusFilterCriteria'
import PartystatusList from './PartystatusList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PartystatusAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPartystatusDashboardPartystatusList } from '../../store/slice/PharmaSlice';

export default function PartystatusListView({setShowEdit,setPartystatusId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.partystatusDashboard);   

    const [filteredPartystatusList, setFilteredPartystatusList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { partystatusDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (partystatusDashboard.partystatusList.length>-1){
        setFilteredPartystatusList(partystatusDashboard.partystatusList);
        transformToCardFormat(partystatusDashboard.partystatusList, setCardList);
      }
    },[partystatusDashboard.partystatusList])

    useEffect(()=>{
          transformToCardFormat(filteredPartystatusList, setCardList);
      },[filteredPartystatusList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredPartystatusList(partystatusDashboard.partystatusList);
            transformToCardFormat(partystatusDashboard.partystatusList, setCardList);

        } else {
            setFilteredPartystatusList(
                partystatusDashboard.partystatusList
                    .filter(partystatus=> partystatus.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(partystatusDashboard.filteredPartystatusList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PartystatusList
                    setShowEdit={setShowEdit}
                    setPartystatusId = {setPartystatusId}
                    tableList={filteredPartystatusList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}